import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';

import FiltersGrid from './filters-grid';
import commonStyles from '../settings-page.module.less';
import messages from './messages';
import NewFilterButton from './new-filter-button';
import style from './style.module.less';
import { FilterEditorContextProvider } from '../../../components/filter-editor/context';
import { pages } from '../../settings/nav-items';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';

const linkPath = `/${pages.settings.location}/${pages.automationRules.location}`;
const linkButton = () => {
  return (
    <NavLink className={style['automation-rules-link']} to={linkPath}>
      <FormattedMessage {...messages.automationRulesLink} />
    </NavLink>
  );
};

export const OrderFilters = () => {
  return (
    <FilterEditorContextProvider>
      <div className={classnames(commonStyles.content, style.content)}>
        <div className={style['top-content']}>
          <SettingsPageTitle value={messages.header} />
          <Text formattedMessageValues={{ a: () => linkButton() }} textType={TextType.Description} value={messages.subheader} />
          <div className={style['primary-action']}>
            <NewFilterButton />
          </div>
        </div>
        <FiltersGrid />
      </div>
    </FilterEditorContextProvider>
  );
};
